import { render, staticRenderFns } from "./FormSatisfacao.vue?vue&type=template&id=327f5b6d&"
import script from "./FormSatisfacao.vue?vue&type=script&lang=js&"
export * from "./FormSatisfacao.vue?vue&type=script&lang=js&"
import style0 from "./FormSatisfacao.vue?vue&type=style&index=0&id=327f5b6d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports